import React, {useState, useEffect, useRef} from 'react';
import Header from '../layout/Header'
import Footer from '../layout/Footer'
import Sidebar from '../layout/Sidebar'
import Breadcrumbs from '../Reusables/Breadcrumbs';
import Calender from '../Reusables/Calender'
import Descriptor from '../Reusables/Descriptor'
import '../../scss/editcreatetask.scss'
import Dropdown from '../Reusables/Dropdown'
import { useDispatch } from 'react-redux';
import { useParams, useNavigate } from "react-router-dom";
import getResponse from '../actions/Project';
import { parseBreadcrumbsList } from '../../store/Actions';
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import RefreshToken from '../actions/RefreshToken';
import Snackbars from '../Reusables/Snackbar';
import Spinner from '../Reusables/Spinner';
import { trim } from '../Reusables/Function';
import { convertToDateString } from '../Reusables/Function';
import { IoIosArrowDown } from "react-icons/io";

function EditCreateTask(props) {
    const accesstoken =  Cookies.get('access_token');
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userId = useSelector((state) => state.userId);

    const path = window.location.href;
    const pathSplit = path.split('/');
    const taskId = parseInt(pathSplit[pathSplit.length - 2]);
    const pageType = pathSplit[pathSplit.length - 1];

    const [enable, setEnable] = useState(true);
    const [page, setPage] = useState('');
    const [name, Setname] = useState(null);
    const [date, setDate] = useState(null);
    const [estimate, setEstimate] = useState(null);
    const [actual, setActual] = useState(null);
    const [billable, setBillable] = useState(null);
    const [descriptiontext, setDescriptionText] = useState(null);
    const [status, setStatus] = useState(null);
    const [priority, setPriority] = useState(null);
    const [assignedto, setAssignedto] = useState(null);
    const [owner, setOwner] = useState(null);
    const [dependencytask, setDependencyTask] = useState(null);
    const [roleid, setRoleid] = useState(null);
    const [statusList, setStatusList] = useState([]);
    const [prorityList, setPriorityList] = useState([]);
    const [taskList, setTaskList] = useState([]);
    const [ownerRoleList, setOwnerRoleList] = useState([]);
    const [roleList, setRoleList] = useState([]);
    const [userList, setUserList] = useState([]);
    const [statusLabel, setStatusLabel] = useState('Select Status');
    const [priorityLabel, setPriorityLabel] = useState('Select Priority');
    const [taskLabel, setTaskLabel] = useState('Select Task');
    const [ownerRoleLabel, setOwnerRoleLabel] = useState('Select Owner Role');
    const [roleLabel, setRoleLabel] = useState('Select Role');
    const [userLabel, setUserLabel] = useState('Select User');
    const [startdate, setStartDate] = useState(false);
    const [label, setLabel] = useState('Select Date');
    const [editlabel, setEditLabel] = useState(null);
    const [edittaskerror, setEdittaskError] = useState('');
    const [open, setOpen] = useState(null);
    const [taskdisable, setTaskDisable] = useState(null);
    const [isLoading, setLoading] = useState(true);
    const [isTaskList, setIsTaskList] = useState(false);
    const [userSearch, setUserSearch] = useState('');
    const [filteredUserList, setFilteredUserList] = useState([]);
    var breadcrumbsList = [];

    const tasksListRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
          if (tasksListRef.current && !tasksListRef.current.contains(event.target)) {
            setIsTaskList(false);
          }
        };
    
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, []);

    const defaultTaskNames = [
        "Project Management",
        "Create Draft",
        "Review Draft",
        "Proof To Internal",
        "Review - Proof To Internal",
        "Proof To Client",
        "List Pull",
        "List Check",
        "Approved to Schedule",
        "Scheduled Deployment",
        "Scheduled with Resend",
        "Adestra Link",
        "Adestra Resend Link",
        "Project Close"
      ];

    useEffect(() => {
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                if(pageType != "edit") {
                    setLoading(false)
                    breadcrumbsList = [
                        { "name": "Home", "url": "" },
                        { "name": "Projects", "url": "projects/list" },
                        { "name": "Task New", "url": `projects/${id}/task/new` }
                    ];
                    dispatch(parseBreadcrumbsList(breadcrumbsList));
                } 

                setPage(pageType);

                // Getting the dropdown list
                GetUserDropdown('', accesstoken);
                GetStatusDropdown();
                GetPriorityDropdown();
                GetTaskDropdown(accesstoken);
                GetOwnerRoleDropdown(accesstoken);
                GetRoleDropdown(accesstoken);

                if(pageType == "edit") {
                    callGetTasksDetailsApi(accesstoken);
                }
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));

    }, [])

    const callGetTasksDetailsApi = (accesstoken) => {  
        getResponse.GetTaskDetails(`/api/project/taskdetails/${taskId}`, accesstoken, (data) => {  
            // if(data.status == 200) {
                const response = data && data.data && data.data.data;
                console.log('[des]description1', response.description)
                if(response ) {
                    setDescriptionText((response.description == null) ? '' : response.description);
                }
                // Breadcrumbs
                breadcrumbsList = [
                    { "name": "Home", "url": "" },
                    { "name": "Projects", "url": "projects/list" },
                    { "name": response.name+": Edit", "url": `projects/${id}/task/${taskId}/edit` }
                ];
                dispatch(parseBreadcrumbsList(breadcrumbsList));

                if(response.dueDate != null && response.dueDate != "") {
                    const date = new Date(response.dueDate);
                    console.log("Date Object", date);
                    setDate(date);
                    setStartDate(date);
                    setEditLabel(convertToDateString(date, "picker"));
                }
                if(response.dueDate == null) {
                    setEditLabel('Select Date');
                }
                if(response.assignedToRoleNavigation != null && response.assignedToRoleNavigation.idRoles != null) {
                    GetUserDropdown(response.assignedToRoleNavigation.idRoles.toString(), accesstoken);
                }

                Setname((response.name != "" && response.name != null) ? response.name : name);
                setStatus(response.status != null ? (response.status == 1 ? "Completed" :  "Incomplete") : status);
                setStatusLabel(response.status != null ? (response.status == 1 ? "Completed" :  "Incomplete") : statusLabel);
                setPriority(response.priority != null ? response.priority : priority);
                setPriorityLabel(response.priority != null ? response.priority : priorityLabel);
                setDependencyTask((response.dependencyTaskNavigation != null && response.dependencyTaskNavigation.idTasks != null) 
                    ? response.dependencyTaskNavigation.idTasks : dependencytask);
                setTaskLabel((response.dependencyTaskNavigation != null && response.dependencyTaskNavigation.name != "" &&
                response.dependencyTaskNavigation.name != null) ? 
                    response.dependencyTaskNavigation.name : taskLabel);
                setOwner((response.ownerRoleNavigation != null && response.ownerRoleNavigation.idRoles != "" &&
                response.ownerRoleNavigation.idRoles != null) 
                    ? response.ownerRoleNavigation.idRoles : owner);
                setOwnerRoleLabel((response.ownerRoleNavigation != null && response.ownerRoleNavigation.roleName != "" && 
                response.ownerRoleNavigation.roleName != null) ? 
                    response.ownerRoleNavigation.roleName : ownerRoleLabel);
                setRoleid((response.assignedToRoleNavigation != null && response.assignedToRoleNavigation.idRoles != null) ? 
                    response.assignedToRoleNavigation.idRoles : roleid);
                setRoleLabel((response.assignedToRoleNavigation != null && response.assignedToRoleNavigation.roleName != ""
                && response.assignedToRoleNavigation.roleName != null) ? 
                    response.assignedToRoleNavigation.roleName : roleLabel);
                setAssignedto((response.assignedToNavigation != null && response.assignedToNavigation.idUsers != null) ? 
                    response.assignedToNavigation.idUsers : assignedto);
               
                if(response.assignedToNavigation && response.assignedToNavigation.firstName !== '' && response.assignedToNavigation.firstName !== undefined && response.assignedToNavigation.firstName !== null) {
                    var firstName = response.assignedToNavigation.firstName;
                }
                else {
                    var firstName = '';
                }
                if(response.assignedToNavigation && response.assignedToNavigation.lastName !== '' && response.assignedToNavigation.lastName !== undefined && response.assignedToNavigation.lastName !== null) {
                    var lastName = response.assignedToNavigation.lastName;
                }
                else {
                    var lastName = '';
                }
                var name = ((firstName || lastName) ? firstName +' '+lastName : '');
                setUserLabel(name ? name : userLabel);
                setLoading(false)
                setEstimate(response.estimatedHrs != null ? response.estimatedHrs : estimate);
                setActual(response.actualHrs != null ? response.actualHrs : actual);
                setBillable(response.billedHrs != null ? response.billedHrs : billable);
            // }    
        }); 
    }
    function handleEditdate(date) {
        setDate(date);
        setStartDate(date);
    }

    function handleNewdate(date) {
        setDate(date);
        setStartDate(date);
    }

    function EditCreate() {
        setEnable(false);
        let datetime = date;
        // UTC time 
        var exactdate = null;
        if(datetime != "" && datetime != null) {
             // Generate yyyy-mm-dd date string
             exactdate = convertToDateString(datetime, "");
        }
        const data = {
            name: trim(name),
            dueDate: exactdate,
            priority: priority,
            estimatedHrs: parseFloat(estimate),
            actualHrs: parseFloat(actual),
            status: status === "Completed" ? 1 : 0,
            billedHrs: parseFloat(billable),
            assignedToRole : roleid,
            ownerRole : owner,
            assignedTo: assignedto,
            owner: userId,
            dependencyTask: dependencytask,
            projectId: id,
            description: descriptiontext == '' ? null : trim(descriptiontext)
        }
        console.log("CREATEDATA", data);
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                if(page == 'edit') {
                    data.idTasks = taskId;
                    getResponse.EditTask(data, `/api/project/${id}/tasks/${taskId}/edit`, accesstoken, (response) => {   
                        setEnable(true);
                        if(response.status === 200) {
                            setLoading(true)
                            setEdittaskError('');
                            setOpen(false)
                            navigate(`/projects/${id}/view`);
                            window.scroll(0, 0);
                        }
                        if(response.status === 404 || response.status === 400) {
                            setLoading(false)
                            setEdittaskError(response.data.message);
                            setOpen(true)                        
                        } else if(response.status == 401) {
                            navigate("/login")
                        }  
                    });
                } else {
                    const URL = `/api/project/${id}/tasks/add`
                    getResponse.CreateTask(data, URL, accesstoken, (response) => {  
                        setEnable(true);     
                        console.log("RESPONSETASK",response);
                        if(response.status === 200) {
                            setLoading(true)
                            navigate(`/projects/${id}/view`);
                            window.scroll(0, 0);
                            setOpen(false);
                        }
                        if(response.status === 404 || response.status === 400) {
                            setLoading(false)
                            setEdittaskError(response.data.message);
                            window.scroll(0, 0);
                            setOpen(true);
                        } else if(response.status == 401) {
                            navigate("/login")
                        } 
                    });
                }
            }
        }

        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    function GetStatusDropdown() {
        setStatusList([
            {id: 1, name: "Completed"}, 
            {id: 2, name: "Incomplete"}
        ])
    }

    function GetPriorityDropdown() {
        setPriorityList([
            {id: 1, name: "1"}, 
            {id: 2, name: "2"},
            {id: 3, name: "3"},
            {id: 4, name: "4"},
            {id: 5, name: "5"}
        ]);
    }

    function GetTaskDropdown(accesstoken) {
        const URL = `/api/Project/${id}/tasks`
        getResponse.GetTaskList(URL, accesstoken, (response) => {
            if(response.status == 200) {
                const taskArray = [];
                const path = window.location.href;  
                const pathSplit = path.split('/');
                const id = parseInt(pathSplit[pathSplit.length - 2]);
                response.data.data.map((task) => {
                    const taskObject = {id: 0, name: ''}
                    console.log(id, task["idTasks"], name, task["name"])
                    if(id != task["idTasks"]) {
                        taskObject.id = task["idTasks"];
                        taskObject.name = task["name"];
                        taskArray.push(taskObject);
                    } else {
                        setTaskDisable(false)
                    }
                })
                taskArray.length == 0 ? setTaskDisable(false) : setTaskDisable(true);
                taskArray.length > 0 && taskArray.sort((a, b) => a.name.localeCompare(b.name));
                console.log("Task array sorted", taskArray);
                setTaskList(taskArray);
            } else if(response.status == 401) {
                navigate("/login")
            }
        });
    }

    function GetOwnerRoleDropdown(accesstoken) {
        getResponse.GetRoleDropdown(accesstoken, (response) => {  
            if(response.status == 200) {
                const ownerRolesArray = getRolesArray(response.data.data);
                setOwnerRoleList(ownerRolesArray);
            } else if(response.status == 401) {
                navigate("/login")
            }
        });
    }

    const getRolesArray = (response) => {
        const ownerRolesArray = [];
        response && response.length > 0 && response.map((role) => {
            const ownerRolesObject = {id: 0, name: ''}
            ownerRolesObject.id = role["idRoles"];
            ownerRolesObject.name = role["roleName"];
            ownerRolesArray.push(ownerRolesObject);
        })
        return ownerRolesArray;
    }

    function GetRoleDropdown(accesstoken) {
        getResponse.GetRoleDropdown(accesstoken, (response) => {
            if(response.status == 200) {
                const rolesArray = getRolesArray(response.data.data);
                setRoleList(rolesArray);
            } else if(response.status == 401) {
                navigate("/login")
            }
        });
    }
    
    function GetUserDropdown(id, accesstoken) {
        const URL = `/api/users/list${id ? `?role=${id}`: '' }`
        console.log('dropURL', URL);
        getResponse.GetUserDropdown(URL, accesstoken, (response) => {
            if(response.status == 200) {
                const usersArray =  getUserList(response.data.data);
                usersArray.sort((a, b) => a.name.localeCompare(b.name))
                setUserList(usersArray);
            } else if(response.status == 401) {
                navigate("/login")
            }
        });
    }

    function getUserList(response) {
        const usersArray = [];
        response.map((user) => {
            const userObject = {id: 0, name: ''}
            userObject.id = user["idUsers"];
            userObject.name = ((user["firstName"] != null && user["lastName"] != null) ? 
                (user["firstName"]+" "+user["lastName"]) : (user["firstName"]));
            userObject.userRole = user["userRole"];
            usersArray.push(userObject);
        })
        return usersArray;
    }

    const handleUserAssignment = (id) => {
        if (roleid == id) return;
        setUserLabel('Select User');
        setRoleid(id);
        GetUserDropdown(id.toString(), accesstoken);
        setUserLabel('Select User');
        setAssignedto(null);
    }

    useEffect(() => {
        setFilteredUserList(userList);
    }, [userList])

    useEffect(() => {
        if(userSearch !== '') {
            const filteredList = userList.filter((user) => user.name.toLowerCase().includes(userSearch.toLowerCase()));
            setFilteredUserList(filteredList);
        } else {
            setFilteredUserList(userList);
        }
    }, [userSearch])

    useEffect(() => {
       if(assignedto) {
        const roleId = filteredUserList.find(list => list.id == assignedto)?.userRole;
        if(!roleId || roleid == roleId) return;
        setRoleid(roleId);
        const role = roleList.find(list => list.id == roleId)?.name;
        if(!role) return;
        setRoleLabel(role);
        GetUserDropdown(roleId.toString(), accesstoken);
       }
    }, [assignedto])

    return (
        <div className='edit-task-container'>
            {console.log("Task name is", name)}
            <Header />
            <div className='row edit-task-section'>
                <Sidebar />
                <div className='col-10 edit-task-right'>
                    <Breadcrumbs />
                    {isLoading ? 
                        (<Spinner/>) : ( 

                    <div className='edit-task-content'>
                        <div className='row label-input-row label-input-row1'>
                            <div className='col-8 label-input-col-large'>
                                <div className='label-input-large col-left-large position-relative'>
                                    <label className='required'>Task</label>
                                    <div className='input-box d-flex align-items-center gap-2'> 
                                        <input type="text" value={name} onChange={(e) => Setname(e.target.value)} maxLength={255}></input> 
                                        <IoIosArrowDown size={20} style={{transform: isTaskList ? 'rotate(180deg)' : '', color: '#059CDC', cursor: 'pointer'}} onClick={() => setIsTaskList(!isTaskList)}/>
                                    </div>
                                    {isTaskList && 
                                        <div ref={tasksListRef} className='d-flex align-items-start flex-column bg-white overflow-auto position-absolute w-100' 
                                            style={{ zIndex: 999, borderRadius: "5px", height: "200px", top: "75px",  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1), 4px 0px 8px rgba(0, 0, 0, 0.05), -4px 0px 8px rgba(0, 0, 0, 0.05)",
                                            }}>
                                            {defaultTaskNames.map((task, index) => (
                                                <div 
                                                    key={index} 
                                                    className='w-100 px-4 py-1 z-1 dropdown-content-inner'
                                                    style={{cursor: 'pointer'}} 
                                                    onClick={() => {
                                                        Setname(task)
                                                        setIsTaskList(false)
                                                    }
                                                }>
                                                {task}
                                                </div>
                                            ))}
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className='col-4 label-input-col '>
                                <div className='label-input col-right'>
                                    <label className='required'>Due Date</label>
                                    {pageType == 'edit' && <Calender minDate={false} maxDate={false} startdate={startdate} 
                                        HandleDate={(date) => handleEditdate(date)} 
                                        HandleLabel={(date) => setEditLabel(convertToDateString(date, "picker"))} 
                                        label={editlabel } disablefromto={false} disableto={false}/>}
                                    {pageType == 'new' &&
                                    <Calender minDate={new Date()} maxDate={false} startdate={startdate} 
                                        HandleDate={(date) => handleNewdate(date)} 
                                        HandleLabel={(date) => setLabel(convertToDateString(date, "picker"))} 
                                        label={label} disablefromto={false} disableto={false}
                                    />
                                    }
                                </div>
                            </div>
                        </div>
                        <div className='row label-input-row label-input-row2'>
                            <div className='col-4 label-input-col'>
                                <div className='label-input-dropdown col-left '>
                                    <label>Status</label>
                                    <Dropdown label={statusLabel} selectedItem={(name, id) => setStatus(name)}
                                     handleLabel={(value) => setStatusLabel(value)} list={statusList} enable={true}/>
                                </div>
                            </div>
                            <div className='col-4 label-input-col'>
                                <div className='label-input-dropdown col-middle'>
                                    <label>Priority</label>
                                    <Dropdown label={priorityLabel} selectedItem={(name, id) => setPriority(id)} 
                                    handleLabel={(value) => setPriorityLabel(value)} list={prorityList} enable={true}/>
                                </div>
                            </div>
                            <div className='col-4 label-input-col'>
                                <div className={taskdisable ? 'label-input-dropdown col-right pointer-all' : 'label-input-dropdown col-right pointer-none'}>
                                    <label className={taskdisable ? '' : 'dropdown-grey'}>Task Dependency</label>
                                    <div>
                                        <Dropdown label={taskLabel} selectedItem={(name, id) => setDependencyTask(id)} 
                                        handleLabel={(value) => setTaskLabel(value)} list={taskList} enable={taskdisable}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row label-input-row label-input-row3'>
                            <div className='col-4 label-input-col'>
                                <div className='label-input-dropdown col-left'>
                                    <label>Owner Role</label>
                                    <Dropdown label={ownerRoleLabel} selectedItem={(name, id) => setOwner(id)} 
                                    handleLabel={(value) => setOwnerRoleLabel(value)} list={ownerRoleList} enable={true}/>
                                </div>
                            </div>
                            <div className='col-4 label-input-col'>
                                <div className='label-input-dropdown col-middle'>
                                    <label>Role Assignment</label>
                                    <Dropdown label={roleLabel} selectedItem={(name, id) => handleUserAssignment(id)} 
                                    handleLabel={(value) => setRoleLabel(value)} list={roleList} enable={true}/>
                                </div>
                            </div>
                            <div className='col-4 label-input-col'>
                                <div className='label-input-dropdown col-right'>
                                    <label 
                                    // className={roleid ? '' : 'dropdown-grey'} 
                                    >User Assignment</label>
                                    <div 
                                    // className={roleid ? 'pointer-all' : 'pointer-none'}
                                    >
                                        <Dropdown 
                                            label={userLabel} 
                                            selectedItem={(name, id) => setAssignedto(id)} 
                                            handleLabel={(value) => setUserLabel(value)} 
                                            list={filteredUserList}
                                            enable={true}
                                            customSearchBar={true}
                                            searchPlaceholder={'Search User'}
                                            searchQuery={userSearch}
                                            setSearchQuery={setUserSearch}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row label-input-row label-input-row4' >
                            <div className='col-4 label-input-col'>
                                <div className='label-input col-left'>
                                    <label>Estimate Hours</label>
                                    <div className='input-box'> 
                                        <input type="text" value={estimate} onChange={(e) => setEstimate(e.target.value)} maxLength={10}></input>
                                        {console.log('estimate', estimate)}
                                    </div>
                                </div>
                            </div>
                            <div className='col-4 label-input-col'>
                                <div className='label-input col-middle'>
                                    <label>Actual Hours</label>
                                    <div className='input-box'> 
                                        <input type="text" value={actual} onChange={(e) => setActual(e.target.value)} maxLength={10}></input>
                                    </div>
                                </div>
                            </div>
                            <div className='col-4 label-input-col'>
                                <div className='label-input col-right'>
                                    <label>Billable Hours</label>
                                    <div className='input-box'> 
                                        <input type="text" value={billable} onChange={(e) => setBillable(e.target.value)} maxLength={10}></input>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row description-row'>
                            <div className='col-12'>
                                <label>Description</label>
                                {pageType == 'edit' ? (
                                    descriptiontext != null && 
                                    <>
                                    {   console.log('[des]description2', descriptiontext && descriptiontext)}  
                                        <Descriptor defaultdescription={descriptiontext && descriptiontext} setDescription={setDescriptionText}/>
                                    </>
                                    ) : (
                                        <Descriptor setDescription={setDescriptionText}/>
                                )}
                            </div>
                            <div className='save-button'>
                                <button disabled={enable ? false : true} className={enable ? 'enable' : 'disable'} onClick={EditCreate}>Save</button>
                            </div>
                        </div>
                    </div>)}
                </div>
            </div>
            <Footer />
            <Snackbars error={edittaskerror} open={open} setOpen={setOpen}/>
        </div>
    );
}

export default EditCreateTask;